var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPandas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 235,
    viewBox: "0 0 171 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.3637 13.8463H47.6824V67.0003H77.3637V13.8463Z",
    fill: "#130754"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3637 123.034H47.6824V176.188H77.3637V123.034Z",
    fill: "#130754"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3637 82.515H47.6824V107.594H77.3637V82.515Z",
    fill: "#FFCA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6813 57.5427H0V234.23H29.6813V57.5427Z",
    fill: "#130754"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.06 166.89H94.3789V220.044H124.06V166.89Z",
    fill: "#130754"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.06 57.6064H94.3789V110.76H124.06V57.6064Z",
    fill: "#130754"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.06 126.286H94.3789V151.364H124.06V126.286Z",
    fill: "#E70488"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.745 0H141.063V176.687H170.745V0Z",
    fill: "#130754"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/pandas.174b30925c48b3d2a2ee4f3557feecd6.svg";
export { ForwardRef as ReactComponent };